module.exports = "/_next/static/images/ObserveYourData@2x-f1fa92edf77dcc8fc5dd21bc01176601.png";